import loadable from "@loadable/component";
import { RouteComponentProps } from "react-router-dom";
import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";

import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";
import loadHomeData from "@Pages/Home/data";
import fetchHomePageData from "@Pages/Home/data/fetchHomePageData";
import fetchHomeV3Data from "./data/fetchHomeV3Data";

const HomeV3 = loadable(() => import("./HomeV3"), {
  fallback: <FullPageLoader />,
});

type Props = RouteComponentProps;

const Home: FC<Props> = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchHomePageData(props));
  }, []);

  return <HomeV3 {...props} />;
};

export default (props: Props): JSX.Element => (
  <ErrorBoundary>
    <Home {...props} />
  </ErrorBoundary>
);

const loadData = (props: any) => [...loadHomeData(props), fetchHomeV3Data(props)];

export { loadData };
